import { FC, useState } from 'react';
import loadable from '@loadable/component';
import {
  ReviewCheckToggleButton,
  ReviewCheckToggleContext,
  ReviewCheckToggleContextType,
} from '#baseMenu/components';
import { ReviewCheckHolder } from '#reviewCheck/containers';
import { useStateCallbacks } from '#reviewCheck/hooks';

const ReviewCheck = loadable(() => import('#reviewCheck/containers/ReviewCheck'), {
  resolveComponent: ({ ReviewCheck: Component }) => Component,
});

const ReviewCheckToggle: FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isLoadInProcess, setIsLoadInProcess] = useState<boolean>(false);
  const stateCallbacks = useStateCallbacks();

  const reviewCheckToggleContextValue: ReviewCheckToggleContextType = {
    ReviewCheck,
    isLoaded,
    setIsLoaded,
    isLoadInProcess,
    setIsLoadInProcess,
  };

  return (
    <ReviewCheckToggleContext value={reviewCheckToggleContextValue}>
      <ReviewCheckToggleButton />
      <ReviewCheckHolder stateCallbacks={stateCallbacks} />
    </ReviewCheckToggleContext>
  );
};

export { ReviewCheckToggle };
